import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Check } from "lucide-react";

const formatPrice = (cents) => {
  if (!cents || cents === 0) return "Free";
  return `R${(cents / 100).toFixed(2)}`;
};

export default function PlanChangeCard({ plan, isCurrent, onSelect }) {
  const isFree = plan.price_monthly === 0 && plan.price_yearly === 0;
  const hubCount = Object.values(plan.hubs || {}).filter(Boolean).length;

  const getPriceDisplay = () => {
    if (isFree) return "Free";
    if (plan.billing_period === "monthly") return `${formatPrice(plan.price_monthly)}/mo`;
    if (plan.billing_period === "yearly") return `${formatPrice(plan.price_yearly)}/yr`;
    if (plan.billing_period === "per_user") return `${formatPrice(plan.price_per_user_monthly)}/user/mo`;
    return "Custom";
  };

  return (
    <Card className={`p-4 relative ${isCurrent ? "ring-2 ring-primary" : ""}`}>
      {isCurrent && (
        <Badge className="absolute -top-2 right-2">Current</Badge>
      )}
      <div className="space-y-2">
        <div className="font-semibold">{plan.name}</div>
        <div className="text-2xl font-bold">{getPriceDisplay()}</div>
        <div className="text-sm text-muted-foreground space-y-1">
          <div className="flex items-center gap-1">
            <Check className="w-3 h-3 text-green-500" />
            {hubCount} hubs
          </div>
          {plan.features?.max_team_members && (
            <div className="flex items-center gap-1">
              <Check className="w-3 h-3 text-green-500" />
              Up to {plan.features.max_team_members} users
            </div>
          )}
          <div className="flex items-center gap-1">
            <Check className="w-3 h-3 text-green-500" />
            {plan.features?.max_storage_gb || 0}GB storage
          </div>
          {plan.features?.api_access && (
            <div className="flex items-center gap-1">
              <Check className="w-3 h-3 text-green-500" />
              API access
            </div>
          )}
          {plan.features?.priority_support && (
            <div className="flex items-center gap-1">
              <Check className="w-3 h-3 text-green-500" />
              Priority support
            </div>
          )}
        </div>
        {!isCurrent && (
          <Button className="w-full mt-2" variant="outline" onClick={onSelect}>
            Switch to {plan.name}
          </Button>
        )}
      </div>
    </Card>
  );
}
